import React,{useState} from "react";
import { View ,StyleSheet,TouchableOpacity,Text} from "react-native";
import {i18n} from "./assets/lang/i18next";
import { useTranslation } from 'react-i18next'
import Dashboard from "./pages/Dashboard";
const StartPage=(props)=>{
    const { t, i18n } = useTranslation();
    const [appIsReady, setAppIsReady] = useState(false);
    return(
        <View style={styles.container}>
<View style={{flex:1,flexDirection:'row',justifyContent:'space-evenly',marginBottom:50}}>
                    <TouchableOpacity onPress={()=>{
                        i18n.changeLanguage("en");
                        setAppIsReady(true);
                       //props.navigation.navigate('ResultBorodatiSimple');
                    }}>
                        <Text>English</Text>
                    </TouchableOpacity>
                    <TouchableOpacity onPress={()=>{
                        i18n.changeLanguage("fa");
                        setAppIsReady(true);
                      //  props.navigation.navigate('ResultBorodatiSimple');
                    }}>
                        <Text>فارسی</Text>
                    </TouchableOpacity>

                </View>
        </View>
    ) 
}

const styles=StyleSheet.create(
    {
        container:{
                    flex:1,
                    padding:10,
                    backgroundColor:'#e6e6e6'
        }
    }
)
export default StartPage;